import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CardsApi, type TopUpRequest, type TopUpResponse, type StoreBaseReturn } from '@shared/api';

interface UseTopUpStore {
  loading: boolean;
  data?: TopUpResponse | null;
  error: string | null;
  createTopUp: (request: TopUpRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<TopUpResponse | null>>;
  clear: () => void;
}

export const useTopUpStore = create<UseTopUpStore>((set) => ({
  loading: false,
  data: undefined,
  error: null,

  createTopUp: async (request, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardsApi.topUp(request, signal);
      set({ loading: false, data: result || null });
      return { loading: false, data: result || null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: null, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: undefined, error: null }),
}));
